import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { EntityTitleHeader, SiteFooterLayout, SiteHeaderProvider, useEntity } from '@shapeable/ui';
import { classNames } from '@shapeable/utils';

const cls = classNames('page-layout-knowledge-hub');

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const FooterStyles = breakpoints({
  base: css`
    
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
  Footer: styled(SiteFooterLayout)`${FooterStyles}`,
};

export const PageLayoutKnowledgeHub: PageLayoutComponent = 
(props) => {
  const { className, slices, children } = props;
  const entity = useEntity(props.entity);

  return (
    <SiteHeaderProvider value={{
      variant: 'default',
    }}>
    <My.Container className={cls.name(className)}>
    <EntityTitleHeader entity={entity} overlayColor='#000' showOverlayGradient colors={{ background: '#F2EAE2'}} />
    {slices}
    </My.Container>
    <My.Footer />
    </SiteHeaderProvider>
  )
};